import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivateFn,
         ActivatedRouteSnapshot,
         RouterStateSnapshot } from '@angular/router';
import { ProjectDetailsFormsMainComponent } from '../main/main.component';

export const canDeactivateFillFormGuard: CanDeactivateFn<ProjectDetailsFormsMainComponent> = (component: ProjectDetailsFormsMainComponent) => {
  // Cehck properties on from the component flags to return true if coudl leave component
  return (component.allowLeave || !component.changesPending);
};
